import React from 'react';

import {
  convertLocationParamsToFetchParams,
  usePolicies,
} from 'app/policies/api';
import {useAddPoliciesToTeam} from 'app/teams/api';

import {AddNewTeamDocButton} from '../components/AddNewTeamDocButton';

import type {OverlayPlacementType} from 'app/general/overlays';
import type {PoliciesFetchParamsType} from 'app/policies/types';
import type {DetailPolicySerializedType, TeamSerializedType} from 'sweet-types';
type Props = {
  team: TeamSerializedType;
  buttonClass?: string;
  placement?: OverlayPlacementType;
};

export const AddNewTeamPolicyButton = ({
  team,
  buttonClass,
  placement,
}: Props) => {
  const [addToTeam] = useAddPoliciesToTeam();

  return (
    <AddNewTeamDocButton<DetailPolicySerializedType, PoliciesFetchParamsType>
      team={team}
      buttonClass={buttonClass}
      placement={placement}
      contentType="policy"
      addAction={addToTeam}
      useDataHook={usePolicies}
      paramsConverter={convertLocationParamsToFetchParams}
    />
  );
};
